import { Component, OnInit, OnChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { StorageService } from './../../../services/storage.service';
import { Eleicao } from './../../../models/eleicao.model';
import { EleicaoService } from './../../../services/eleicao.service';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {
  eleicao: Eleicao;
  ID_eleicaoAtiva: number = 1;
  showPage: boolean = false;
  urlFoto?: string;
  logo: any;

  constructor(
    public eleicaoService: EleicaoService,
    private spinner: NgxSpinnerService,
    private storage: StorageService
  ) { }

  ngOnInit() {
    this.showSpinner();
  }

  showSpinner() {
    this.spinner.show();
    setTimeout(() => {
     // this.urlFoto = 'https://meufuturo.net.br/voto/imgs/logo/logo-branco-banesprev.png'
      // this.spinner.hide();
      // this.getEleicaoPorId();
      this.showPage = true
    }, 2500);
  }
}
